(function($) {
    $(document).ready(function() {
        var canada = ThemeJS.Cookies.get( 'canada' );
        console.log(canada);
        if ( $("#canada_popup").length > 0 && canada !== 'eh' ) {
            $("#canada_popup").modal('show');
        }

        $('#canada_popup').on('hidden.bs.modal', function (e) {
            ThemeJS.Cookies.set( { canada: { value: 'eh', expires: 365 } } );
        });
    });
})(jQuery);